export default "<p>teacher works!</p>\n"